import type { ThmRouteObject } from 'src/common/interfaces';
import { Navigate } from 'react-router-dom';
import { routeProtector } from 'src/router/route-protector';
import { ThemeColorMode } from 'src/common/enums';
import { fullScreen, rootHandle, withoutFooter } from '../helpers';
export const ttxRoutes: ThmRouteObject[] = [{
  path: '/ttx',
  loader: routeProtector().requireFeatureFlag('ttx'),
  async lazy() {
    const {
      Ttx
    } = await import('src/features/ttx');
    return {
      Component: Ttx
    };
  },
  handle: rootHandle,
  children: [{
    path: '',
    // TODO: replace with public landing pages
    element: <Navigate to="dashboard" />
  }, {
    path: 'evaluation/public/:encryptedRunId',
    async lazy() {
      const {
        Evaluation
      } = await import('src/features/ttx/evaluation');
      return {
        Component: props => <Evaluation {...props} isPublic />
      };
    },
    handle: {
      hideHeader: true,
      ...withoutFooter,
      name: 'evaluation_summary_public'
    }
  }, {
    path: '',
    loader: routeProtector().requireCompletedOnboardingAndWelcome(),
    handle: withoutFooter,
    children: [{
      // guard wrapper for routes that should not be accessible if there is an active run
      path: '',
      async lazy() {
        const {
          TtxActiveRunGuard
        } = await import('src/features/ttx');
        return {
          Component: TtxActiveRunGuard
        };
      },
      children: [{
        path: 'dashboard',
        async lazy() {
          const {
            TTXDashboard
          } = await import('src/features/ttx/dashboard');
          return {
            Component: TTXDashboard
          };
        },
        handle: {
          ...withoutFooter,
          name: 'ttx_dashboard',
          isHeaderTransparent: true,
          isHeaderSticky: false
        }
      }, {
        path: 'generation',
        async lazy() {
          const {
            ScenarioGeneration
          } = await import('src/features/ttx/scenario-generation');
          return {
            Component: ScenarioGeneration
          };
        },
        handle: {
          ...withoutFooter,
          name: 'ttx_generation'
        }
      }, {
        path: 'scenario/:scenarioId',
        loader: routeProtector().requireFeatureFlag('ttx-custom-exercise'),
        async lazy() {
          const {
            ScenarioReview
          } = await import('src/features/ttx/scenario-review');
          return {
            Component: ScenarioReview
          };
        },
        handle: {
          ...withoutFooter,
          name: 'ttx_scenario_review'
        }
      }, {
        path: 'scenario/:scenarioId/:stageId',
        loader: routeProtector().requireFeatureFlag('ttx-custom-exercise'),
        async lazy() {
          const {
            Customize
          } = await import('src/features/ttx/customize');
          return {
            Component: Customize
          };
        },
        handle: {
          name: 'ttx_customize',
          forcedTheme: ThemeColorMode.DARK
        }
      }, {
        path: 'join/:runId',
        async lazy() {
          const {
            TtxJoinRun
          } = await import('src/features/ttx');
          return {
            Component: TtxJoinRun
          };
        },
        handle: {
          name: 'ttx_join'
        }
      }, {
        path: 'evaluation/:runId',
        async lazy() {
          const {
            Evaluation
          } = await import('src/features/ttx/evaluation/evaluation');
          return {
            Component: Evaluation
          };
        },
        handle: {
          isHeaderTransparent: true,
          isHeaderSticky: false,
          name: 'ttx_evaluation',
          ...withoutFooter
        }
      }]
    }, {
      // guard wrapper for routes that should only be accessible if there is an active run
      path: '',
      async lazy() {
        const {
          TtxRoom
        } = await import('src/features/ttx');
        return {
          Component: TtxRoom
        };
      },
      children: [{
        path: 'lobby',
        async lazy() {
          const {
            TtxLobby
          } = await import('src/features/ttx');
          return {
            Component: TtxLobby
          };
        },
        handle: {
          ...fullScreen,
          name: 'ttx_lobby',
          hideIntercom: true
        }
      }, {
        path: 'exercise',
        async lazy() {
          const {
            Exercise
          } = await import('src/features/ttx');
          return {
            Component: Exercise
          };
        },
        handle: {
          ...fullScreen,
          hideIntercom: true,
          name: 'ttx_exercise'
        }
      }]
    }]
  }]
}];